import React, { useState } from 'react';
import AppSidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

// Appwrite imports
import { Client, Databases, Storage, ID } from 'appwrite';

// Initialize Appwrite client
const client = new Client();
client
  .setEndpoint('https://cloud.appwrite.io/v1')
  .setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const AddPoem = () => {
  const { currentUser } = useAuth();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [editId, setEditId] = useState(null);

  // Upload image to Appwrite Storage
  const uploadImage = async (file) => {
    try {
      const response = await storage.createFile(BUCKET_ID, ID.unique(), file);
      return response.$id;
    } catch (error) {
      console.error('Error uploading image:', error);
      return null;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let imageId = null;
      if (image) {
        imageId = await uploadImage(image);
      }

      if (editId) {
        // Update existing poem
        await databases.updateDocument(DATABASE_ID, COLLECTION_ID, editId, {
          title,
          content,
          imageId,
        });
        setEditId(null);
      } else {
        // Create new poem
        await databases.createDocument(DATABASE_ID, COLLECTION_ID, ID.unique(), {
          title,
          content,
          imageId,
          userId: currentUser.uid,
          createdAt: new Date().toISOString(),
        });
      }

      // Clear form
      setTitle('');
      setContent('');
      setImage(null);

      // Optionally, navigate to another page like 'mypoems' after posting
      // (depends on your router setup, e.g., react-router)
      // Example:
      // navigate('/mypoems');

      alert('Poem posted successfully!');

    } catch (error) {
      console.error('Error saving poem:', error);
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex">
      <div className="sticky top-0 h-screen">
        <AppSidebar user={currentUser} />
      </div>
      <div className="flex-1 ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen">
        <h1 className="text-2xl font-bold mb-4">Add a new poem</h1>

        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md mb-6">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Poem Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              placeholder="Enter your poem title"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2 ">Poem Content</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
              rows="6"
              placeholder="Write your poem here..."
              required
            ></textarea>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Upload Image (optional)</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
            />
          </div>

          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300">
            {editId ? 'Update Poem' : 'Post Poem'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPoem;
